export function handleMaskingNumber(contact_number, maskingPrefix, maskingSufix){
    let number = contact_number.split("");
    let frontNumber = number.splice(0, Number(maskingPrefix));
    let lastNumber = number.splice(Number(-maskingSufix));
    let frontNumberString = frontNumber.join("");
    number.forEach((item) => {
      frontNumberString = frontNumberString + "*";
    });
    return frontNumberString + lastNumber.join("");
  };